import "./Threekit.css";
import {
  LoadingSpinner,
  OptionsUtility,
  AddToCartUtility,
  ModalAlert,
  CustomizeTools,
} from "./imports";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateCartItems, updateOptions } from "./redux/reducers/threekitSlice";
import { setLoading } from "./redux/reducers/threekitSlice";
import styled from "styled-components";
import ProductDetail from "./components/ProductDetail";
import ProductDetailHead from "./components/ProductDetailHead";
import { device } from "../../utils/breakPoints";
import BuilderImageGallery from "./components/BuilderImageGallery";
import ProductDescription from "./components/ProductDescription";
import ProductRecommendations from "./components/Recommendations/ProductRecommendations";
import { checkUploadedFile } from "./redux/creators/threekitCreators";
import { isFreeItem, freeTitle } from "./helpers/promoProduct";

export default function ThreekitSingleProduct() {
  const dispatch = useDispatch();
  const {
    loading,
    showCustomize,
    selectedProduct,
    addToCartDisabled,
    hasUploadedFile,
    error,
    state,
  } = useSelector((state) => ({
    state,
    ...state.threekit,
    ...state.fabric,
    hasUploadedFile: checkUploadedFile(state),
  }));

  const [productTitle, setProductTitle] = useState('');

  const optionsUtility = new OptionsUtility({
    state,
    setCartItems: (item) => dispatch(updateCartItems(item)),
    setOptions: (item) => dispatch(updateOptions(item)),
  });

  useEffect(() => {
    optionsUtility.fetchCartItems();
    const title = getProductTitle();
    setProductTitle(title);
    // eslint-disable-next-line
  }, [selectedProduct, addToCartDisabled]); // <-- add dependencies

  async function addToCart() {
    dispatch(setLoading(true));
    new AddToCartUtility(state).addToCart();
  }

  function isAddToCartDisabled() {
    return !selectedProduct.available || addToCartDisabled;
  }

  function getProductTitle() {
    let productTitle = selectedProduct.name || selectedProduct.title;

    if (isFreeItem(selectedProduct)) {
      productTitle = freeTitle(selectedProduct);
    }

    if (isAddToCartDisabled()) {
      productTitle += " - Out Of Stock";
    }

    return productTitle;
  }

  function getCurrentPrice() {
    if (isFreeItem(selectedProduct) && !hasUploadedFile) {
      return "0.00";
    } else {
      return optionsUtility.totalPriceInCurrency;
    }
  }

  return (
    <>
      {loading && <LoadingSpinner />}
      {error.active && <ModalAlert />}
      {showCustomize && <CustomizeTools optionsUtility={optionsUtility} />}
      <Container>
        <FirstSection>
          <BuilderImageGallery />
          <DesktopDescriptionContainer>
            <ProductDescription selectedProduct={selectedProduct} />
          </DesktopDescriptionContainer>
        </FirstSection>
        <SecondSection>
          <ProductDetail
            selectedProduct={selectedProduct}
            title={productTitle}
            addToCart={addToCart}
            isAddToCartDisabled={isAddToCartDisabled}
            optionsUtility={optionsUtility}
            manualPrice={getCurrentPrice()}
          />
          <MobileDescriptionContainer>
            <ProductDescription selectedProduct={selectedProduct} />
          </MobileDescriptionContainer>
        </SecondSection>
      </Container>
      <ProductRecommendations />
    </>
  );
}

const Container = styled.div`
  display: flex;
  padding: 50px 30px 0;
  justify-content: center;
  margin-right: auto;
  margin-left: auto;
  gap: 2em;
  max-width: 1500px;
  @media ${device.tablet} {
    flex-direction: column;
    padding: 0 15px 40px;
  }
`;
const FirstSection = styled.div`
  width: 100%;
  @media ${device.tablet} {
    min-height: auto;
    margin-right: auto;
    margin-left: auto;
  }
`;
const SecondSection = styled.div`
  width: 100%;
  @media ${device.tablet} {
    padding-right: 0;
  }
`;
const DesktopDescriptionContainer = styled.div`
  padding: 36px 24px 40px 0;
  @media ${device.tablet} {
    display: none;
  }
`;
const MobileDescriptionContainer = styled.div`
  display: none;
  @media ${device.tablet} {
    display: block;
  }
`;